
import { OpCodeState } from './../../store/opcode/opcode.reducer';
import { Store } from '@ngrx/store';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { INavigateAway } from '../../shared/guards/NavigationGuard';
import { MatDialog } from '@angular/material/dialog';
import { exitConfig, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { SubscriptionList } from '../../shared/models/asp.types';

@Component({
  selector: 'app-opcode-service-management',
  templateUrl: './opcode-service-management.component.html',
  styleUrls: ['./opcode-service-management.component.scss']
})
export class OpcodeServiceManagementComponent implements OnInit,INavigateAway, OnDestroy{

  formsEdited=true;
  saveClicked=false;
  private subs: SubscriptionList = {};
  
  constructor(private readonly opCodeStore: Store<OpCodeState>,
  public readonly dialog: MatDialog,
  private readonly cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
  }
  
  canExit():Observable<boolean> { 
    const result = new Subject<boolean>();
    const dialogRef = this.dialog.open(ConfirmDialogComponent,exitConfig
      ); 
    this.subs.dialogRef = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
      this.saveClicked=true;
      if (!this.cdr['destroyed']) {
        this.cdr.detectChanges();
      }
      result.next(true);
      result.complete();
      }
      else if (event.action === 'close'){
      result.next(true);
      result.complete();
      }
    });
    return result.asObservable(); 
  };

   // returns if the forms are edited
   formsNotEdited()
   {
     return this.formsEdited; 
   }

   valuesChanged(event)
   {
    this.formsEdited=event;
   }

   ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
    this.cdr.detach();
  }

}
